import { isEmpty } from "lodash-es";

import { assertNever } from "../utils/assertNever";
import { getRequestHeaders } from "../utils/getRequestHeaders";

const API_URL = process.env.NEXT_PUBLIC_API_URL ?? "";

export class ResponseError extends Error {
    public statusCode: number | undefined;

    constructor(message?: string, statusCode?: number) {
        super(message);
        this.statusCode = statusCode;
    }
}

export async function fetchWithAuth(
    path: string,
    responseType: "blob" | "json" | "text",
    opts?: {
        headersInit?: HeadersInit;
        init?: RequestInit;
        defaultErrorMessage?: string;
        skipAuth?: boolean;
    },
) {
    const headers = opts?.skipAuth ? opts?.headersInit : await getRequestHeaders(opts?.headersInit);

    const response = await fetch(`${API_URL}${path}`, {
        headers,
        ...opts?.init,
    });

    if (response.ok) {
        switch (responseType) {
            case "blob":
                return response.blob();
            case "json":
                return response.json();
            case "text":
                return response.text();
            default:
                return assertNever(responseType);
        }
    } else {
        const err = await parseErrorResponse(response, opts?.defaultErrorMessage);
        throw new ResponseError(err ?? response.statusText, response.status);
    }
}

async function parseErrorResponse(response: Response, defaultErrorMessage?: string): Promise<string | undefined> {
    try {
        const error = await response.json();
        if (!isEmpty(error?.errors?.display_error)) {
            return error.errors.display_error;
        }
        return defaultErrorMessage;
    } catch {
        return defaultErrorMessage;
    }
}
